export class ServiceRequestClient {
    /**Nombre */
    public name: string;
    /**Apellidos */
    public lastName: string;
    /**Código de tipo de documento */
    public documentTypeCode: string;
    /**Nombre de tipo de documento */
    public documentTypeName: string;
    /**Número de documento */
    public documentNumber: string;
    /**Teléfono fijo */
    public homePhone: string;
    /**Celular */
    public cellPhone: string;
    /**Correo electrónico */
    public emailAddress: string;
    /**Tipo de cliente */
    public type: string;
    /**Código de cliente */
    public code: string;
    /**Id de Interlocutor  */
    public interlocutorId: string;
}